//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {IKey} from '../../../types/key';
import {EncryptionService} from '../../../services/encryption.service';
import {BehaviorSubject, Observable} from 'rxjs';

export class KeysDataSource extends DataSource<IKey> {

  private keys$: BehaviorSubject<IKey[]> = new BehaviorSubject<IKey[]>([]);
  private _length: number;

  constructor(private readonly encryptionService: EncryptionService) {
    super();
  }

  connect(collectionViewer: CollectionViewer): Observable<IKey[]> {
    return this.keys$.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.keys$.complete();
  }

  fetch() {
    this.encryptionService.getKeys().subscribe(response => {
      this._length = response.keys.length;
      this.keys$.next(response.keys);
    });
  }

  get length(): number {
    return this._length;
  }
}
